export default {
    methods: {
        createUniqKey(num = 1) {
            return +num + (Math.round(Math.random() * 1000) * Math.round(Math.random() * 1000));
        },
    }
};